/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import ProveedorEstado from '@infotrack/presentacion-componentes/proveedorEstado';
import React from 'react';
import FormualrioGrupoActividadEconomicaCV from './controladorVista/formularioGrupoActividadEconomicaCV';
import TablaGrupoActividadEconomicaCV from './controladorVista/tablaGrupoActividadEconomicaCV';
import { estadoIncial, reductor } from './reductorGrupoActividadEconomica';

const GrupoActividadEconomica: React.FunctionComponent = () => (
    <ProveedorEstado estadoInicial={estadoIncial} reductor={reductor}>
        <TablaGrupoActividadEconomicaCV />
        <FormualrioGrupoActividadEconomicaCV />
    </ProveedorEstado>
);

export default GrupoActividadEconomica;
